import React, { useEffect, useState } from 'react';
import VerticalLayout from '../components/layouts/VerticalLayout';
import HorizontalLayout from '../components/layouts/HorizontalLayout';
import { useSessionContext } from '../contexts/SessionContext';
import { notEmpty } from '../utils/types';
import BranchSelector, { VendorBranchOption } from '../components/BranchSelector';
import VendorInfo from '../components/VendorInfo';
import CoverageMap from '../components/tiles/CoverageMap';
import { Button, CircularProgress, MessageBox } from '@opendoor/mosaic';
import useGetVendorBranch from '../graphql/queries/bender/useGetVendorBranch';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import BranchInfo from '../components/tiles/BranchInfo';
import Capabilities from '../components/tiles/Capabilities';
import { GetWebSession_web_userSession_human_vendorBranches } from '../graphql/athena/types/GetWebSession';

const sessionBranchToBranchOption = (
  branch: GetWebSession_web_userSession_human_vendorBranches,
): VendorBranchOption => {
  return {
    id: branch.id,
    branchName: branch.name,
    vendorName: branch.vendor?.name || 'Missing Vendor Name',
    vendorId: branch.vendor?.id || 'no-id',
  };
};

const Profile = () => {
  const [selectedBranch, setSelectedBranch] = useState<VendorBranchOption>();
  const { session } = useSessionContext();
  const branches: GetWebSession_web_userSession_human_vendorBranches[] =
    session.human?.vendorBranches.filter(notEmpty) || [];

  const { data, loading, error, refetch } = useGetVendorBranch({
    variables: { id: selectedBranch?.id },
    skip: !selectedBranch,
  });

  const vendorBranch = data?.vendor?.getVendorBranchByID?.vendorBranch;
  useEffect(() => {
    if (!selectedBranch && branches.length) {
      setSelectedBranch(sessionBranchToBranchOption(branches[0]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!branches?.length]);

  return (
    <VerticalLayout>
      <VerticalLayout className="bo-gray3 bob-3 pt-6 pl-9">
        <h2>{selectedBranch?.vendorName}</h2>
        <VendorInfo vendor={vendorBranch?.vendor || undefined} />
        <div className="mt-4 pa-4 bo-blue4 bob-1 blue4 w-6 ml--2">Branches</div>
      </VerticalLayout>
      <HorizontalLayout>
        <BranchSelector
          className="w-9 mt-4"
          selectedVendorBranch={selectedBranch}
          onVendorBranchSelected={setSelectedBranch}
          vendorBranches={branches.map(sessionBranchToBranchOption)}
        />
        <VerticalLayout className="pa-4 bg-blue1 w-100% bo-gray2 bol-2">
          {loading && <CircularProgress className="mh-auto" />}
          {error && (
            <MessageBox
              image={<ErrorOutlineRoundedIcon className="h-5 w-5 mh-auto" />}
              description={`Error fetching the vendor branch: ${error}`}
              extra={
                <Button className="mt-4" color="primary" onClick={() => refetch()}>
                  Please try again
                </Button>
              }
            />
          )}
          <HorizontalLayout className="flex-wrap">
            <BranchInfo branch={vendorBranch || undefined} />
            <Capabilities capabilities={vendorBranch?.capabilities || undefined} />
          </HorizontalLayout>
          <CoverageMap regionId={vendorBranch?.fenceId || undefined} vendorBranch={vendorBranch} />
        </VerticalLayout>
      </HorizontalLayout>
    </VerticalLayout>
  );
};

export default Profile;
